import { render, staticRenderFns } from "./LinkContacts.vue?vue&type=template&id=0e5ca3b6&"
import script from "./LinkContacts.vue?vue&type=script&lang=js&"
export * from "./LinkContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports